import React, { useState } from 'react';
import { X } from 'lucide-react';
import { FolderSelector } from './FolderSelector';
import { Folder } from '../../types/shared';

interface FolderSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (folder: Folder | null) => void;
  title?: string;
  currentFolderId?: string | null;
}

export const FolderSelectorModal: React.FC<FolderSelectorModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  title = "Seleccionar Carpeta",
  currentFolderId
}) => {
  const [selectedFolder, setSelectedFolder] = useState<Folder | null>(null);

  if (!isOpen) return null;

  const handleSelect = () => {
    onSelect(selectedFolder);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-gray-900 rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <h2 className="text-xl font-semibold text-white">{title}</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-700 rounded transition-colors"
          >
            <X className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4">
          <FolderSelector
            selectedFolderId={selectedFolder?._id || currentFolderId}
            onFolderSelect={setSelectedFolder}
            showSearch={true}
            className="border-0 shadow-none bg-transparent"
          />
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-4 border-t border-gray-700">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-700 text-gray-300 rounded-lg hover:bg-gray-600 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={handleSelect}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            Seleccionar
          </button>
        </div>
      </div>
    </div>
  );
};

export default FolderSelectorModal;
